import { render, staticRenderFns } from "./jywj-folder.vue?vue&type=template&id=0e50ab86&scoped=true&"
import script from "./jywj-folder.vue?vue&type=script&lang=ts&"
export * from "./jywj-folder.vue?vue&type=script&lang=ts&"
import style0 from "./jywj-folder.vue?vue&type=style&index=0&id=0e50ab86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50ab86",
  null
  
)

export default component.exports